import styled from 'styled-components';
import Tag from '@mlb/react-patterns/v4/components/Tag/tag';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import breakpoints from 'bdata-sns-shared/mini/utils/miniBreakpoints';
import { StyledBaseSkeleton } from '@mlb/react-patterns/v4/components/Skeleton/skeleton.style';

const {
    blueRibbon,
    mlbGrey5
} = COLORS;

export const StatusLayerWrapper = styled.div`
    font-size: 10px;
    line-height: 10px;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    padding-top: ${({ theme }) => {
        return theme.StatusLayerWrapper?.paddingTop || '8px';
    }};
    padding-left: 4px;
    height: 10px;
    box-sizing: content-box;

    ${({ $mode, $visibility }) => {
        if ($mode === 'infinity') {
            return `
                height: auto;
                padding-left: 8px;
                padding-right: 8px;
                padding-bottom:0;        
                font-size: 11px;
            `;
        }

        if ($mode === 'vertical') {
            return `
                padding-left:0;
                margin-bottom: 6.5px;
                visibility: ${$visibility ? 'visible' : 'hidden'};
            `;
        }
    }};

`;

export const GameStateLabelWrapper = styled.span.attrs({
    'data-mlb-test': 'gameStateContainerMobile'
})`
    color: ${mlbGrey5};
    white-space: nowrap;
    text-transform: uppercase;
    display: block;

    ${StyledBaseSkeleton} {
        margin-top: 2px;
    }

    padding: ${({ theme }) => theme.GameStateLabelWrapper.padding};
    height: ${({ theme }) => theme.GameStateLabelWrapper.height};
    line-height: ${({ theme }) => theme.GameStateLabelWrapper.lineHeight};
    
    ${({ $mode }) => {
        if ($mode === 'gameday') {
            return `
                @media (max-width: ${breakpoints.mobile}) {
                    display: block;
                    padding: ${({ theme }) => theme.GameStateLabelWrapper.padding};
                    line-height: ${({ theme }) => theme.GameStateLabelWrapper.lineHeight};
                }

            `;
        }
    }};
`;

export const TagOverride = styled(Tag).attrs({
    'data-mlb-test': 'notableGameLabel'
})`
    white-space: nowrap;
    &.short {
        display:none;
    }
    width: auto;
    border-radius: 2px;
    font-weight: 700;
    padding: ${({ theme }) => theme.GameStateLabelWrapper.padding};
    font-size: ${({ theme }) => theme.StatusLayerWrapper.fontSize};
    line-height: ${({ theme }) => theme.GameStateLabelWrapper.lineHeight};
    height: ${({ theme }) => theme.StatusLayerWrapper.fontSize};
    text-transform: capitalize;
    transform: translateY(-1px);
    ${({ $mode, $labelAlignment }) => {
        if ($mode === 'gameday') {
            return `
                margin-right: 8px;


                @media (max-width: ${breakpoints.mobile}) {
                    &.full {
                        display:none;
                    }
            
                    &.short {
                        display: inline-block;
                    }
                }
            `;
        }

        if ($mode === 'infinity') {
            return `
                height: 12px;
                background-color: ${blueRibbon};
                transform: translateY(-1px);
                padding: 1px 2px 0 2px;
            `;
        }

        if ($mode === 'vertical') {
            return `
                border-radius: 0px 0px 5px 0px;
                border-radius: ${$labelAlignment === 'right' ? '0px 0px 0px 5px' : '0px 0px 5px 0px'};
                font-style: normal;
                font-weight: 600;
                font-size: 11px;
                line-height: 11px;
                padding: 1px 4px 0 4px;
                height: 11px !important;
                display: inline-block !important;
            `;
        }
    }};
`;

export const BroadcastWrapper = styled.div`
    display: none;

    > div, img {
        height: 13px;
        max-width: 35px;
    }

    @media (max-width: ${breakpoints.mobile}) {
        display: block;
    }
`;

export const TieBreakerWrapper = styled(GameStateLabelWrapper).attrs({
    'data-mlb-test': 'tieBreakerLabel'
})``;
